import { render, staticRenderFns } from "./GuardCodes.vue?vue&type=template&id=59497b4e"
import script from "./GuardCodes.vue?vue&type=script&lang=ts"
export * from "./GuardCodes.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports